module.exports = __webpack_public_path__ + "07_face.4d2da335.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/07_face.png
// module id = pIRH
// module chunks = 0